import { Flex, useDisclosure } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { FetchDimensionList } from 'redux/BuilderModeSlice';
import {
  getActionCreateStatus,
  getDataImportFiles,
  getImportDataFiles,
  getSelectedDataFileDetails,
} from 'redux/DataImportSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

import AddSourceModal from './AddSourceModal';
import Header from './Header';
import SourceDetail from './SourceDetail';
import SourcesTable from './SourcesTable';
import SourcesTableSkeleton from './SourcesTableSkeleton';

const DataImport = () => {
  const dispatch: AppDispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { modelId } = useParams();
  const ImportDataFiles = useSelector(getImportDataFiles);

  const selectedFileDetails = useSelector(getSelectedDataFileDetails);
  const [actionCreate, setactionCreate] = useState(false);
  const actionCreateStatus = useSelector(getActionCreateStatus);

  // Sync local state when Redux actionCreateStatus changes (e.g. form closed from within)
  useEffect(() => {
    setactionCreate(actionCreateStatus);
  }, [actionCreateStatus]);

  // Calling imported files and dimension list for that particular model
  useEffect(() => {
    if (modelId) {
      dispatch(getDataImportFiles(modelId));
      dispatch(FetchDimensionList(modelId));
    }
  }, [modelId]);

  // The slice auto-opens a source's detail screen whenever a model has exactly
  // one source, which skips the list entirely. A detail screen only counts as
  // opened if it was already open before this page mounted (nav dropdown click)
  // or the user opened it from the list — an auto-open alone keeps the list up.
  const openedBeforeMount = useRef(selectedFileDetails?.deatsilsPage === true);
  const [hasOpenedSource, setHasOpenedSource] = useState(openedBeforeMount.current);
  useEffect(() => {
    if (selectedFileDetails?.deatsilsPage !== true) setHasOpenedSource(false);
  }, [selectedFileDetails?.deatsilsPage]);

  const isSourceList =
    !actionCreate && !(selectedFileDetails?.deatsilsPage === true && hasOpenedSource);

  return (
    <Flex width='100%' align='flex-start' justify='center' height={'100%'}>
      <Flex
        h={'100%'}
        w={'100%'}
        flexDirection={'column'}
        justifyContent='flex-start'
        align='start'
      >
        {isSourceList && <Header onOpen={onOpen} />}
        {isSourceList ? (
          ImportDataFiles === null || ImportDataFiles === undefined ? (
            <SourcesTableSkeleton />
          ) : (
            <SourcesTable
              sources={ImportDataFiles}
              onAddSource={onOpen}
              onOpenSource={() => setHasOpenedSource(true)}
            />
          )
        ) : (
          <SourceDetail actionCreate={actionCreate} setActionCreate={setactionCreate} />
        )}
      </Flex>
      <AddSourceModal
        onClose={() => {
          onClose();
        }}
        isOpen={isOpen}
      />
    </Flex>
  );
};

export default DataImport;
